(function ($) {

  // writes the strings

  // https://stackoverflow.com/questions/13325008/typewriter-effect-with-jquery
  
  function typeString($target, str, cursor, delay, cb) {

    if(!str) { return }

    $target.html(function (_, html) {

      return html + str[cursor]
    })
    
    if (cursor < str.length - 1) {

      setTimeout(function () {

        typeString($target, str, cursor + 1, delay, cb)

      }, delay)

    } else {

      $target.html($target.html() + '<br>')

      cb()
    }
  }

  // jQuery hook
  $.fn.extend({
    teletype: function (opts) {

      var settings = $.extend({}, $.teletype.defaults, opts)
      
      return $(this).each(function () {
        (function loop($tar, idx) {
          
          typeString(
            $tar, 
            settings.text[idx], 
            0, 
            settings.delay,  
            function () {

              if(idx > settings.text.length - 2) { return settings.end() }

              loop($tar, idx + 1)
            }
          )
        
        }($(this), 0))
      })
    }
  })

  // plugin defaults  
  $.extend({
    teletype: {
      defaults: {
        delay: 100,
        pause: 5000,
        text: []
      }
    }
  })
}(jQuery))